import $ from 'jquery';
import 'bootstrap-notify'

$(document).on("turbolinks:load",function(){
	$("#function_3_1,#function_3_2").each(function(form) {
		var that = this;
		var counter = 0;
		var msg;
		var type;
		var max_ferie = $(this).data('o-max-ferie');
		var act_ferie = max_ferie - $(this).find('table td.day.selected').length;

		//$.notify('<strong>Hai a disposizione ' + act_ferie + ' giorni di ferie; clicca sulle date per selezionarle/deselezionarle.</strong>', { allow_dismiss: false });

		

		//click di una cella
		$(this).find('table td.day').not('.blacked').click(function(){
		//$(this).find('table td.day').click(function(){
			$(this).toggleClass('selected');
			var selected = $(this).hasClass('selected');
			$(this).find('input.selectable_day[type=hidden]').val(selected);
			if(selected)
			{	$(this).find('label').text($(this).data('selected-text'));
				act_ferie--;
			}
			else
			{	$(this).find('label').text($(this).data('unselected-text'));
				act_ferie++;
			}
			if($(this).hasClass('booked'))
			{	$(this).addClass('unbooked');
				$(this).removeClass('booked');
			}
			else 
			{	if($(this).hasClass('unbooked'))
				{	$(this).addClass('booked');
					$(this).removeClass('unbooked');
				}
			}
			/*
			$.notifyClose();
			switch(true)
			{	case act_ferie > 0:
					msg = '<strong>Hai a disposizione ancora '+ act_ferie + ' giorni di ferie</strong>';
					type = 'success';
					break;
				case act_ferie == 0:
					msg = '<strong>Hai esaurito i giorni di ferie!</strong>';
					type = 'warning';
					break;
				case act_ferie < 0:
					msg = '<strong>Stai richiedendo '+ (-act_ferie) + ' giorni di ferie oltre il limite massimo di ' + max_ferie + ' giorni</strong>';
					type = 'danger';
					break;
			} 
			$.notify(msg, { allow_dismiss: false, type: type});*/
		});
	}); 
});